// ABOUTME: Owns the shareable workout link params (?workoutID=<id>&athlete=<userID>).
// ABOUTME: One format for the card that writes the link and the loader that reads it back.

import { ATHLETE_URL_PARAM, NUTRITION_URL_PARAM, WORKOUT_URL_PARAM } from "./calendarLinkParams"

const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

/** The meal plan link (?nutrition=YYYY-MM-DD&athlete=<id>) shares `athlete` with us. */
export { WORKOUT_URL_PARAM, ATHLETE_URL_PARAM }

export interface WorkoutUrlTarget {
  id: string
  /** Whose calendar the workout belongs to — a coach needs it to open an athlete's workout. */
  userID?: string
}

export const parseWorkoutUrl = (search: string): WorkoutUrlTarget | null => {
  const params = new URLSearchParams(search)
  const raw = params.get(WORKOUT_URL_PARAM)
  if (!raw) return null

  // Links shared before the athlete moved into its own param carry it inside
  // this one value as `<id>&<userID>`.
  const [id, legacyUserID] = raw.split("&")
  if (!id || !UUID_RE.test(id)) return null

  const athlete = params.get(ATHLETE_URL_PARAM) ?? legacyUserID
  return athlete && UUID_RE.test(athlete) ? { id, userID: athlete } : { id }
}

export const buildWorkoutSearch = (search: string, target: WorkoutUrlTarget | null): string => {
  const params = new URLSearchParams(search)

  if (target) {
    params.set(WORKOUT_URL_PARAM, target.id)
    if (target.userID) params.set(ATHLETE_URL_PARAM, target.userID)
    else params.delete(ATHLETE_URL_PARAM)
  } else {
    params.delete(WORKOUT_URL_PARAM)
    if (!params.has(NUTRITION_URL_PARAM)) params.delete(ATHLETE_URL_PARAM)
  }

  const next = params.toString()
  return next ? `?${next}` : ""
}
